import { useImageReady } from '@frontend/design-system';

export const ImageWithTransition = ({ src, alt = '' }: { src: string; alt?: string }) => {
  const imgProps = useImageReady();
  return <img {...imgProps} src={src} alt={alt} />;
};
